module.exports = __webpack_public_path__ + "img/symbol_0.96a5c6a5.png";